import isMobile from 'ismobilejs'

class WhatsApp {
  constructor(el) {
    this.button = el
    this.isMobile = isMobile(window.navigator).any
    this.phone = this.button.dataset.phone
    this.label = this.button.dataset.label || 'Hablemos por WhatsApp'

    if (this.phone) {
      this.init()
    }
  }

  init() {
    const url = this.isMobile
      ? `https://api.whatsapp.com/send/?phone=${this.phone}`
      : `https://web.whatsapp.com/send/?phone=${this.phone}`

    this.button.innerHTML = `
      <a href="${url}" target="_blank">
        ${this.label}
      </a>
    `
  }
}

const whatsApp = {
  // eslint-disable-next-line consistent-return
  init() {
    const wrapperEl = document.querySelectorAll('.menu-item--whatsapp')
    Array.from(wrapperEl).forEach(button => new WhatsApp(button))
  },
}

export default whatsApp
